export function getMockUrl(url: string) {
    return `http://localhost:5190/api${url}`;
}
